import { createFileRoute } from '@tanstack/react-router';
import { NovaVisita } from '@/modules/agronomia/visita/components/NovaVisita';

// Visita técnica que cobre MAIS DE UMA fazenda do mesmo produtor (aberta pelo
// "Adicionar" da tela do produtor). O talhão de cada ponto sai do GPS, entre os
// talhões de todas as fazendas escolhidas.
export const Route = createFileRoute('/_authed/agronomia_/visita-multi')({
  validateSearch: (s: Record<string, unknown>): { imoveis: string } => ({
    imoveis: typeof s.imoveis === 'string' ? s.imoveis : '',
  }),
  component: Page,
});

function Page() {
  const { imoveis } = Route.useSearch();
  const ids = imoveis
    .split(',')
    .map((x) => Number(x.trim()))
    .filter((x) => Number.isFinite(x) && x > 0);
  return <NovaVisita imovelIds={ids} />;
}
